import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {fetchDeveloperIfNeeded} from '../actions/apps-by-type';
import {openCategory} from '../actions/categories';
import AppBoxCollection from '../components/App-box-collection';

class DeveloperApps extends React.Component {

  static fetchData(dispatch, params, location) {
    if (location.query.ids) {
      return dispatch(fetchDeveloperIfNeeded(location.query.ids.split(',')));
    }
  }

  componentWillMount() {
    this.props.dispatch(openCategory('developer-apps'));
  }

  render() {
    const apps = this.props.items;
    return (
      <div className="short-header-page secondary-inner-page">

        <div className="section section-pad section-vertical-pad">
          <h1 className="title">
            <span className="typography_h1">
              <FormattedMessage id="category.developerApps.name"/>
            </span>
          </h1>
          <h2 className="sub-title">
            <span className="typography_t1">
              <FormattedMessage id="category.developerApps.description"/>
            </span>
          </h2>
        </div>

        {this.props.isFetching ?
          <div className="circle-loader"></div> : ''}

        <div className="app-box-grid section section-pad-left">
          {apps.map((app, i) =>
            <div className="col col-1-4" key={app.slug}>
              <AppBoxCollection app={app} reviews={this.props.reviews} biPosition={i + 1}/>
            </div>
          )}
        </div>

      </div>
    );
  }
}

DeveloperApps.propTypes = {
  items: PropTypes.array.isRequired,
  reviews: PropTypes.object,
  isFetching: PropTypes.bool,
  params: PropTypes.object,
  dispatch: PropTypes.func,
  location: PropTypes.object.isRequired
};


function mapStateToProps(state) {
  return {
    items: state.appsByType.developer.items,
    reviews: state.reviews.all
  };
}

export default connect(mapStateToProps)(DeveloperApps);



// WEBPACK FOOTER //
// ./containers/Developer-apps.js